// Lets a visitor who already submitted the quote land on the next-steps screen days later, instead of an
// empty wizard that invites a duplicate. localStorage on purpose (it outlives the tab), so it holds only a
// random read-only token and the lead id: no name, no email. The server answers with a masked email.

export interface SavedReturningLead {
  leadId: string;
  returnToken: string;
  savedAt: string;
}

const STORAGE_KEY = 'casa-aragon-wizard:returning-lead';

export const loadReturningLead = (): SavedReturningLead | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as SavedReturningLead;
    return typeof parsed.leadId === 'string' && typeof parsed.returnToken === 'string' ? parsed : null;
  } catch {
    return null;
  }
};

export const saveReturningLead = (leadId: string, returnToken: string) => {
  try {
    const saved: SavedReturningLead = { leadId, returnToken, savedAt: new Date().toISOString() };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(saved));
  } catch {
    // Storage unavailable (private mode, quota) - the visitor just won't be recognised next time
  }
};

export const clearReturningLead = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
};
